@if (context(); as ctx) {
    <div
        class="fixed bottom-6 right-6 z-[80] flex w-[300px] flex-col gap-3.5 rounded-2xl border border-zinc-200/70 bg-twComponentBackground/95 p-4 shadow-popMenu backdrop-blur-md">
        <!-- Status row -->
        <div class="flex items-center justify-between gap-2">
            @if (isActive()) {
                <span
                    class="flex items-center gap-1.5 text-[11.5px] font-semibold uppercase tracking-[0.08em] text-emerald-600">
                    <span class="relative flex size-2">
                        <span
                            class="absolute inline-flex size-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
                        <span
                            class="relative inline-flex size-2 rounded-full bg-emerald-500"></span>
                    </span>
                    {{ 'voice.call.bar.onCall' | translate }}
                </span>
                <span class="font-mono text-[12.5px] tabular-nums text-zinc-500">{{
                    elapsedLabel()
                }}</span>
            } @else if (isRinging()) {
                <span
                    class="flex items-center gap-1.5 text-[11.5px] font-semibold uppercase tracking-[0.08em] text-primary-700">
                    <span class="relative flex size-2">
                        <span
                            class="absolute inline-flex size-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
                        <span
                            class="relative inline-flex size-2 rounded-full bg-primary-500"></span>
                    </span>
                    {{ 'voice.call.bar.ringing' | translate }}
                </span>
                <lucide-icon
                    class="text-primary-400"
                    [img]="PhoneOutgoingIcon"
                    [size]="14"
                    [strokeWidth]="1.75" />
            } @else {
                <span
                    class="flex items-center gap-1.5 text-[11.5px] font-semibold uppercase tracking-[0.08em] text-zinc-500">
                    <lucide-icon
                        class="animate-spin"
                        [img]="LoaderIcon"
                        [size]="13"
                        [strokeWidth]="2" />
                    {{ 'voice.call.bar.connecting' | translate }}
                </span>
            }
        </div>

        <!-- Caller -->
        <div class="flex items-center gap-3">
            <tw-contact-avatar
                class="shrink-0"
                size="lg"
                [id]="ctx.conversationId"
                [imgUrl]="ctx.contactImage"
                [name]="ctx.contactName" />
            <div class="flex min-w-0 flex-col">
                <span
                    class="truncate text-[14px] font-semibold tracking-[-0.005em] text-twTextPrimary">
                    {{ ctx.contactName || ('voice.call.bar.unknown' | translate) }}
                </span>
                <span class="flex min-w-0 items-center gap-1.5">
                    @if (isWhatsapp()) {
                        <span
                            class="inline-flex shrink-0 items-center gap-1 rounded-md bg-zinc-50 px-1.5 py-px text-[10.5px] font-medium text-zinc-600 ring-1 ring-inset ring-zinc-200/70">
                            <app-contact-channel-icons
                                class="size-3"
                                [channel]="VOICE_CHANNEL"
                                [voiceType]="WA_TYPE" />
                            WhatsApp
                        </span>
                    }
                    @if (ctx.origin) {
                        <span class="truncate font-mono text-[12px] text-zinc-500">{{
                            ctx.origin
                        }}</span>
                    }
                </span>
            </div>
        </div>

        <!-- Controls -->
        <div class="flex items-center gap-2">
            <button
                class="tw-icon-btn size-10 shrink-0"
                [class.tw-icon-btn-danger]="muted()"
                type="button"
                [attr.aria-label]="
                    (muted() ? 'voice.call.bar.unmute' : 'voice.call.bar.mute') | translate
                "
                [disabled]="!isActive()"
                [title]="(muted() ? 'voice.call.bar.unmute' : 'voice.call.bar.mute') | translate"
                (click)="toggleMute()">
                <lucide-icon
                    [img]="muted() ? MicOffIcon : MicIcon"
                    [size]="17"
                    [strokeWidth]="1.75" />
            </button>
            <button
                class="inline-flex h-10 flex-1 items-center justify-center gap-1.5 rounded-xl bg-red-600 text-[13px] font-semibold text-white transition-colors hover:bg-red-700"
                type="button"
                (click)="hangup()">
                <lucide-icon [img]="HangupIcon" [size]="16" [strokeWidth]="1.75" />
                {{ (isRinging() ? 'voice.call.bar.cancel' : 'voice.call.bar.hangup') | translate }}
            </button>
        </div>
    </div>
}
